/**
 * @fileoverview Full blog page (list + detail) routed at `/blog`.
 */

import React from "react";
import Blog from "../components/Blog";

const BlogPage = () => {
  return <Blog variant="full" />;
};

export default BlogPage;

